module.exports = __webpack_public_path__ + "static/media/itinerary2-demo.f309bf79.png";